// Module-scoped token storage — not accessible from window/global scope.
// On init, consumes the token from window.Rails.helpers.authToken and clears it.

const BROADCAST_CHANNEL_NAME = 'brokerkit_auth_token';

let currentToken = null;
let channel = null;

const initBroadcastChannel = () => {
  if (typeof BroadcastChannel === 'undefined') {
    return;
  }

  channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
  channel.onmessage = (event) => {
    if (event.data?.type === 'token_refreshed' && event.data?.token) {
      currentToken = event.data.token;
    }
  };
};

const init = () => {
  // Consume token from global and clear it
  if (Rails?.helpers?.authToken) {
    currentToken = Rails.helpers.authToken;
    delete Rails.helpers.authToken;
  }

  initBroadcastChannel();
};

const getToken = () => currentToken;

const setToken = (token) => {
  currentToken = token;

  // Broadcast to other tabs
  if (channel) {
    try {
      channel.postMessage({ type: 'token_refreshed', token });
    } catch {
      // BroadcastChannel may be closed
    }
  }
};

// Initialize immediately on module load
init();

const getCSRFToken = () =>
  document.querySelector("meta[name='csrf-token']")?.getAttribute('content');

export { getToken, setToken, getCSRFToken };
